<app-dialog-header  label="Seleccionar report" i18n-label></app-dialog-header>
<ul class="reports">
  <div *ngFor="let report of reports">
    <li (click)="SelectReport(report)">
      {{report.nom}}
    </li>
  </div>
  
</ul>
